<script setup>
import { Modal } from "bootstrap";
import { onMounted, watch, ref } from "vue";
import useEventListener from "../../hooks/useEventListener";

const emits = defineEmits(["update:modelValue", "success", "cancel", "show", "hide"]);
const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
	btnSecondary: {
		type: String,
		default: null,
	},
	btnPrimary: {
		type: String,
		default: null,
	},
	modalClass: {
		type: String,
		default: "",
	},
	isEnabled: {
		type: Boolean,
		default: true,
	}
});

const myModalEl = ref(null);
const instance = ref();
useEventListener(myModalEl, "hide.bs.modal", () => {
	emits("hide");
	emits("update:modelValue", false);
});

useEventListener(myModalEl, "show.bs.modal", () => {
	emits("show");
	emits("update:modelValue", true);
});

onMounted(() => {
	instance.value = new Modal(myModalEl.value);
	if (props.modelValue) instance.value?.show();
});

watch(
	() => props.modelValue,
	value => (value ? instance.value.show() : instance.value.hide())
);
</script>

<template>
	<div ref="myModalEl" class="modal fade" :class="modalClass">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<button
						type="button"
						class="btn-close"
						data-bs-dismiss="modal"
						aria-label="Close"
					></button>
					<div v-if="$slots.header" class="modal-title"><slot name="header"></slot></div>
				</div>
				<div v-if="$slots.body" class="modal-body">
					<div><slot name="body"></slot></div>
				</div>
				<div v-if="btnSecondary || btnPrimary" class="modal-footer">
					<button
						v-if="btnSecondary"
						type="button"
						class="btn btn-secondary"
						data-bs-dismiss="modal"
						@click="$emit('cancel')"
					>
						{{ btnSecondary }}
					</button>
					<button
						v-if="btnPrimary"
						type="button"
						class="btn btn-primary"
						:class="{ 'btn_disabled': !isEnabled }"
						data-bs-dismiss="modal"
						@click="$emit('success')"
					>
						{{ btnPrimary }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss"></style>
